import React, { useState } from 'react';
import styled from 'styled-components';
import compose from 'lodash/fp/compose';
import ContentTemplate from 'components/common/ContentTemplate';
import { Button } from 'components/common/FormItems';
import {
  withBulkDelete,
  withUserLayoutChoice,
  withTranslation,
} from 'components/hoc';
import { DnDPortal } from 'components/common/FormItems/DnDPortal';
import withFileSize from 'components/hoc/FileSizeChecker/File';
import {
  TrashFill,
  Clipboard2,
  PlusLg,
} from 'react-bootstrap-icons';
import Swal from 'sweetalert2';

const ButtonWrapper = styled.div`
  margin-top: 10px;
`;

const HeaderWrapper = styled.div`
  margin-top: 10px;
  disply: flex;
  justify-content: space-between;
  align-items: center;
  width: 92%;
`;

const StyledButton = styled(Button)`
  background: var(--admincat-color-grey-6);
  border-radius: 2px;
  height: 38px;
  color: ${(props) => props.color || 'var(--admincat-color-grey-7)'};
  border: none;
  font-size: 14px;
  line-height: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledContentTemplate = styled(ContentTemplate)`
  div.table-responsive {
    height: auto;
    min-height: 70vh;
    max-height: 70vh;
    overflow-y: auto;
    background: var(--admincat-color-grey-1);
    width: auto;
    max-width: 93%;

    @media screen and (max-width: 768px) {
      min-height: 70vh;
      max-height: 70vh;
      overflow-y: auto;
      width: auto;
      background: var(--admincat-color-grey-1);
      max-width: 85%;
    }

    @media screen and (min-width: 1200px) {
      min-height: 70vh;
      max-height: 70vh;
      overflow-y: auto;
      background: var(--admincat-color-grey-1);
      width: auto;
      max-width: 93%;
    }
  }
`;

const MyAdminContentTemplate = (props) => {
  const {
    toggleForm,
    bulkDelete = () => {},
    rowIds,
    hasBulkDelete,
    viewData,
    getLayoutColumnProps,
    tableName,
    frontendTableName: fTableName = null,
    backendTableName: bTableName = null,
    columns: defaultColumns = [],
    useAddModalForm = true,
    handleCreateForm = null,
    isFile,
    msg,
    tr,
    revertView,
    viewName = false,
    gotoDetailPath,
    handleViewForm,
    options,
    goBack,
    setRowDetailToState = () => {},
    executeOnRowClick = () => {},
    handleGoBack = () => {},
    contract = {},
    marginTop,
    filterableColumns = [],
    applyFilter = () => {},
    ...rest
  } = props;
  const [openFilterForm, setOpenFilterForm] = useState(false);

  const frontendTableName = fTableName || tableName;
  const backendTableName = bTableName || tableName;

  const { columns, layoutColumns } = getLayoutColumnProps(
    frontendTableName,
    backendTableName,
    defaultColumns,
  );

 
  const deleteBulk = async () => {
    if (rowIds.length === 0) {
      Swal.fire(
        tr('Warning!'),
        tr(`You have not selected any item to delete`),
        'warning',
      );
      return;
    }
    try {
      await bulkDelete(rowIds);
    } finally {
      return;
    }
  };

  const viewTimeDependentName = () => {
    if (rowIds.length === 0) {
      Swal.fire(tr('Warning!'), tr(`You have not selected any item to view`), 'warning');
      return;
    }

    let viewOption = options.filter(
      (option) => option.name.toLowerCase() === 'Update Name'.toLowerCase(),
    );
    viewOption = viewOption.length > 0 ? viewOption[0] : () => {};
    const idToView = rowIds[0];

    viewOption.onClick({ id: idToView });
    return;
  };

  const onAddClicked = handleCreateForm || toggleForm;

  return (
    <React.Fragment>
      {msg}
      <HeaderWrapper className="flex">
        <ButtonWrapper className="flex" style={{ marginBottom: '15px' }}>
          {useAddModalForm && (
            <StyledButton
              className="option-btn"
              name="Add"
              reactIcon={<PlusLg color="#0E8436" size={12} className="mr-2" />}
              onClick={() => onAddClicked()}
              disabled={isFile}
            />
          )}
          {hasBulkDelete && (
            <StyledButton
              className="option-btn"
              onClick={deleteBulk}
              reactIcon={<TrashFill color="#F00" size={16} className="mr-3" />}
              // disabled={!rowIds.length}
              name="Delete Marked"
            />
          )}
          <DnDPortal tableName={frontendTableName} columns={layoutColumns} />
          {viewName && (
            <StyledButton
              className="option-btn"
              onClick={viewTimeDependentName}
              reactIcon={<Clipboard2 color="#4C818E" size={16} className="mr-3" />}
              // disabled={!rowIds.length}
              name="View Name"
            />
          )}
        </ButtonWrapper>
      </HeaderWrapper>

      <StyledContentTemplate
        {...rest}
        columns={columns}
        hasBulkDelete={hasBulkDelete}
        viewData={viewData}
        rowIds={rowIds}
        showDetailOnRowClick
        setRowDetailToState={setRowDetailToState}
        executeOnRowClick={executeOnRowClick}
      />
    </React.Fragment>
  );
};


export default compose(
  withBulkDelete,
  withUserLayoutChoice,
  withFileSize,
  withTranslation,
)(MyAdminContentTemplate);
